export { VOIP_CAMPAIGNS, VOIP_CAMPAIGNS_NAMES_MAP } from './voip';
